import { Question } from "@hubcapp/views/MyBusinessProfile/types";

export const tagOptions = {
  teachingEnjoyment: [
    "Seeing students gain confidence",
    "Helping students learn a valuable skill",
    "Promoting road safety",
    "Teaching road awareness",
    "Interacting with different people",
    "Watching students progress",
    "Making a positive impact",
    "Encouraging responsible driving",
    "Developing problem solving skills",
    "Building relationships with students",
    "Sharing my passion for driving",
    "Preparing students for real-word driving",
    "Contributing to community safety",
    "Enjoying the teaching process",
    "Seeing students pass their driving test",
  ],
  teachingStyle: [
    "Focused on real world scenarios",
    "Gradual skill development",
    "Confidence building",
    "Personalised for student needs",
    "Stress management techniques",
    "Improvement focused",
    "Step by step",
    "Safety focused",
    "Goal oriented",
    "Clear and concise",
    "Practical",
    "Positive reinforcement",
    "Motivational",
    "Empathetic",
    "Student centred",
    "Calm",
    "Detailed",
    "Interactive",
    "Structured",
    "Encouraging",
    "Supportive",
    "Patient",
    "Adaptable",
    "Flexible",
  ],
  rewardingMostRewardingAspect: [
    "Seeing students gain confidence",
    "Helping students achieve independence",
    "Watching students improve",
    "Contributing to road safety",
    "Making a positive impact on lives",
    "Building strong relationships with students",
    "Celebrating students passing their driving test",
    "Teaching a lifelong skill",
    "Empowering new drivers",
    "Witnessing personal growth",
    "Encouraging responsible driving habits",
    "Sharing my passion for driving",
    "Helping students overcome challenges",
    "Seeing the joy in students' success",
    "Preparing students for real world driving",
  ],
  selfDescription: [
    "Friendly",
    "Honest",
    "Loyal",
    "Optimistic",
    "Patient",
    "Reliable",
    "Responsible",
    "Thoughtful",
    "Trustworthy",
    "Outgoing",
    "Sociable",
    "Extroverted",
    "Introverted",
    "Reserved",
    "Shy",
    "Hardworking",
    "Dedicated",
    "Ambitious",
    "Motivated",
    "Proactive",
    "Empathetic",
    "Compassionate",
    "Kind",
    "Supportive",
    "Understanding",
    "Sensitive",
    "Articulate",
    "Good listener",
    "Clear speaker",
    "Strategic thinker",
    "Tech-savvy",
  ],
  freeTimeActivities: [
    "Football",
    "Rugby",
    "Running",
    "Swimming",
    "Golf",
    "Tennis",
    "Hiking",
    "Fishing",
    "Rock climbing",
    "Gym",
    "Yoga",
    "Pilates",
    "CrossFit",
    "Aerobics",
    "Weightlifting",
    "Surfing",
    "Sailing",
    "Kayaking",
    "Meditation",
    "Watching movies",
    "Reading",
    "Playing instruments",
    "Attending concerts",
    "Video games",
    "Board games",
    "Arts and crafts",
    "Photography",
    "Hanging out with friends",
    "Spending time with family",
    "Volunteering",
    "Travel",
    "Camping",
    "Cooking",
    "Exploring new restaurants",
    "Baking",
    "Learning new languages",
    "Bird watching",
    "Stargazing",
    "Classic cars",
    "Go-kart racing",
    "Motorcycling",
    "Skiing",
    "Mountain biking",
    "Badminton",
  ],
};

export const questions: Question[] = [
  {
    key: "teaching_enjoyment",
    label: "What three things do you enjoy most about teaching new drivers?",
    tags: tagOptions.teachingEnjoyment,
  },
  {
    key: "teaching_style",
    label: "In what three ways would you describe your teaching style?",
    tags: tagOptions.teachingStyle,
  },
  {
    key: "most_rewarding_aspect",
    label:
      "What are the three most rewarding parts about being a driving instructor?",
    tags: tagOptions.rewardingMostRewardingAspect,
  },
  {
    key: "self_description",
    label: "What three characteristics would you use to describe yourself",
    tags: tagOptions.selfDescription,
  },
  {
    key: "free_time_activities",
    label: "What are three activities you enjoy during your free time?",
    tags: tagOptions.freeTimeActivities,
  },
];
